module.exports = __webpack_public_path__ + "fa-brands-400.svg?1d5619cd804367cefe6da2d79289218a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/webfonts/fa-brands-400.svg
// module id = 1451
// module chunks = 0